/**
 * Comprehensive Scroll Reveal & Micro-Interactions Engine
 */
(function() {
  'use strict';

  function initScrollReveal() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // 1. Auto-discover sections and attach reveal classes if not explicitly set
    const allSections = document.querySelectorAll('section');
    allSections.forEach(function(sec) {
      if (!sec.classList.contains('hero-section')) {
        const secHeader = sec.querySelector('.section-header, .max-w-3xl, .max-w-2xl');
        if (secHeader && !secHeader.classList.contains('reveal-on-scroll')) {
          secHeader.classList.add('reveal-on-scroll');
        }

        const cards = sec.querySelectorAll('.service-card, .case-study-card, .principle-card, .timeline-step, .tech-cat-card, .insight-card, .trust-card, .accordion-item');
        cards.forEach(function(card, idx) {
          if (!card.classList.contains('reveal-on-scroll') && !card.classList.contains('reveal-fade-left') && !card.classList.contains('reveal-fade-right')) {
            card.classList.add('reveal-on-scroll');
          }
          if (!card.style.transitionDelay) {
            card.style.transitionDelay = (idx % 4 * 0.08) + 's';
          }
        });
      }
    });

    const revealElements = document.querySelectorAll('.reveal-on-scroll, .reveal-fade-left, .reveal-fade-right, .reveal-scale, .reveal-blur');

    if (!revealElements.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      revealElements.forEach(function(el) {
        el.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver(function(entries, obs) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          
          // Trigger metric counter animation if present
          const counters = entry.target.querySelectorAll('[data-counter]');
          counters.forEach(function(counter) {
            animateCounter(counter);
          });

          obs.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    revealElements.forEach(function(el) {
      observer.observe(el);
    });

    // 2. Animated Counter Helper
    function animateCounter(el) {
      const targetVal = parseFloat(el.getAttribute('data-counter'));
      const suffix = el.getAttribute('data-suffix') || '';
      const decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
      const duration = 1200;
      const startTime = performance.now();

      function updateNumber(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easeOutQuad = 1 - (1 - progress) * (1 - progress);
        const currentVal = targetVal * easeOutQuad;

        el.textContent = currentVal.toFixed(decimals) + suffix;

        if (progress < 1) {
          requestAnimationFrame(updateNumber);
        } else {
          el.textContent = targetVal.toFixed(decimals) + suffix;
        }
      }

      requestAnimationFrame(updateNumber);
    }

    // 3. Subtle 3D Card Tilt on Mouse Move
    if (!prefersReducedMotion && window.innerWidth >= 1024) {
      const interactiveCards = document.querySelectorAll('.interactive-card');
      interactiveCards.forEach(function(card) {
        card.addEventListener('mousemove', function(e) {
          const rect = card.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;
          const centerX = rect.width / 2;
          const centerY = rect.height / 2;
          const deltaX = (x - centerX) / centerX;
          const deltaY = (y - centerY) / centerY;

          card.style.transform = 'perspective(1000px) rotateX(' + (-deltaY * 3.5) + 'deg) rotateY(' + (deltaX * 3.5) + 'deg) translateY(-4px)';
        });

        card.addEventListener('mouseleave', function() {
          card.style.transform = '';
        });
      });
    }
  }

  window.GinaScrollReveal = { init: initScrollReveal };
})();
